import { regex } from './regex';

export const sanitizeString = (str: string) => str.replace(regex.SANITIZE_QUERY, '\\$&')
